import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

import { Component } from 'react';
import { withRouter } from 'react-router-dom';

import ImporterHeader from 'components/importer/ImporterHeader';
import ImporterApi from 'api/importer';
import DbApi from 'api/db';
import DataGrid from 'react-data-grid';
import NoRecords from 'components/ui/DataGrid/NoRecords';
import DownloadButton from 'components/ui/buttons/DownloadButton';
import SubmitButton from 'components/ui/buttons/SubmitButton';

import { withTranslation } from 'react-i18next';
import { MoonLoader } from 'react-spinners';
import NotificationHelper from 'helpers/NotificationHelper';
import AWSHelper from 'helpers/AWSHelper';

class ImporterPage extends Component {
  state = {
    data: [],
    uploading: false,
  };

  componentDidMount() {
    this.fetchData();
  }

  async fetchData() {
    const { match } = this.props;
    const { db_id } = match.params;
    const data = await ImporterApi.all('databases', { db_id });
    this.setState({ data });

    setTimeout(this.fetchData.bind(this), 6000);
  }

  async onSubmit(e) {
    e.preventDefault();

    const { match } = this.props;
    const { db_id } = match.params;
    const id = uuidv4();

    this.setState({ uploading: true });

    await ImporterApi.create({
      id,
      type: 'databases',
      payload: {
        db_id,
      },
    });

    const files_input = document.querySelector('#file');
    const Body = files_input.files[0];

    const params = {
      Bucket: 'files.youfy.com.br/databases',
      Key: `${db_id}/${id}.csv`,
      Body,
    };

    try {
      await AWSHelper.upload2S3(params);
      e.target.reset();
    } catch (error) {
      console.error(error);
      NotificationHelper.dispatch('Falha ao enviar arquivo.');
    } finally {
      this.setState({ uploading: false });
    }
  }

  dataFormatter = ({ column, row }) => {
    const date_value = row[column.key];

    if (!date_value) {
      return '--';
    }

    return moment(date_value).format('DD/MM/YYYY HH:mm');
  };

  // Removido por questões de segurança.
  // actionFormatter = ({ column, row }) => {
  //   return (
  //     <div>
  //       <a
  //         title="Baixar o arquivo"
  //         className="btn btn-icon"
  //         href={`https://files.youfy.com.br/databases/${row.id}.csv`}
  //         rel="noreferrer"
  //         target="_blank">
  //         <FiDownload size={22} />
  //       </a>
  //     </div>
  //   );
  // };

  statusFormatter = ({ row }) => {
    const { t } = this.props;

    switch (row.status) {
      case 'FAILED':
        return <div className="text-danger text-uppercase">{t('status.failed')}</div>;

      case 'PROCESSING':
        return (
          <div className="text-primary d-flex align-items-center justify-content-between">
            <MoonLoader size={16} color="#7930e2" />
            <div className="ms-3 text-uppercase">{t('status.processing')}</div>
          </div>
        );

      case 'DONE':
        return <div className="text-success text-uppercase">{t('status.done')}</div>;

      default:
        return <div className="text-muted text-uppercase">{t('status.pending')}</div>;
    }
  };

  render() {
    const { match, t } = this.props;
    const { db_id } = match.params;

    const columns = [
      { key: 'status', name: 'Status', formatter: this.statusFormatter },
      { key: 'attempts', name: t('columns.attempts') },
      { key: 'created_at', name: t('columns.created_at'), formatter: this.dataFormatter },
      { key: 'started_at', name: t('columns.started_at'), formatter: this.dataFormatter },
      { key: 'done_at', name: t('columns.done_at'), formatter: this.dataFormatter },
      // { key: 'actions', name: '', formatter: this.actionFormatter },
    ];

    const rows = this.state.data;
    const template_request = DbApi.getTemplate.bind(DbApi, db_id);

    const file_name = `${db_id}.csv`;

    return (
      <>
        <ImporterHeader dbId={db_id} />

        <div className="container mt-5">
          <div className="row align-items-center">
            <form onSubmit={this.onSubmit.bind(this)} className="col-md-6">
              <div className="input-group">
                <input required type="file" id="file" className="form-control" />
                <SubmitButton type="submit" tkey="actions.import" loading={this.state.uploading} className="btn btn-primary" />
              </div>
            </form>

            <div className="col-md-6">
              <DownloadButton
                className="btn btn-link"
                tkey="importer.actions.download_template"
                request_promise={template_request}
                file_name={file_name}
              />
            </div>
          </div>
          <div></div>
        </div>

        <div className="container mt-5">
          <DataGrid columns={columns} rows={rows} className="data-grid rdg-light" rowName="row" rowHeight={60} emptyRowsRenderer={NoRecords} />
        </div>
      </>
    );
  }
}

export default withTranslation()(withRouter(ImporterPage));
